import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import {
  getAllHiring,
  getAllPageSections,
  getAllSubscribers,
} from "store/actions";

import Table from "./Table";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { hiring, loading, error } = useSelector((state) => state.hiring);

  const { formatMessage, locale } = useIntl();

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  useEffect(() => {
    dispatch(getAllHiring());
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <Table data={hiring} loading={loading} />
    </div>
  );
};

export default ContactUs;
